import mutations from './mutations.js';
import getters from './getters.js';
import actions from './actions.js';
export default {
  namespaced: true,
  state() {
    return {
      isLoggedIn: false,
      userID: null,
      token: null,
      fname: '',
      lname: '',
      experience: false,
      access_type: false,
      notifications: [],
    };
  },
  mutations,
  actions,
  getters,
};
